import appPlans from "../../views/appPlans/index.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "plans";
  const params = ["page", "limit"];

  $stateProvider.state("plans", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appPlans,
      },
    },
    reloadOnSearch: false,
    data: { title: "Plans" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/plans/plans.urls.js